import { FC, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { MaterialReactTable, MRT_ColumnDef, MRT_PaginationState, useMaterialReactTable } from 'material-react-table'
import { Button } from '@mui/material'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import mrtLocalization from '../../constants/mrtLocalization'
import { Prp2boxApiLimit } from '../../prp2boxApi'
import { IRpLimit } from '../../prp2boxApi/limits'
import { useStore } from '../../stores'
import { EDrawerView } from '../../stores/DrawerCRUD.store'
import { EQueryKeysConstant } from '../../constants/EQueryKeysConstant'

const columns: MRT_ColumnDef<IRpLimit>[] = [
  {
    accessorKey: 'name',
    header: 'Имя',
  },
  {
    accessorKey: 'min',
    header: 'Минимум',
  },
  {
    accessorKey: 'max',
    header: 'Максимум',
    Cell: ({ cell }) => {
      return cell.getValue<number | null>() || 'no limit'
    },
  },
  {
    accessorKey: 'maxPayout',
    header: 'Максимальная выплата',
    Cell: ({ cell }) => {
      return cell.getValue<number | null>() || 'no limit'
    },
  },
]

const RpLimitsTable: FC = observer(() => {
  const { drawerCRUDStore } = useStore()
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  })

  const { data, isError, isLoading, isFetching } = useQuery(
    [EQueryKeysConstant.RP_LIMITS, pagination.pageIndex, pagination.pageSize],
    async () => {
      return Prp2boxApiLimit.getLimits({
        limit: pagination.pageSize,
        offset: pagination.pageIndex * pagination.pageSize,
      })
    },
    {
      refetchOnWindowFocus: false,
      onError: (err) => toast.error(`${err}`),
      enabled: true,
      keepPreviousData: true,
    }
  )

  const table = useMaterialReactTable({
    ...mrtLocalization,
    enableGlobalFilter: false,
    data: data?.rows || [],
    columns,
    rowCount: data?.totalRows || 0,
    state: {
      pagination,
      isLoading,
      showAlertBanner: isError,
      showProgressBars: isFetching,
    },
    manualPagination: true,
    onPaginationChange: setPagination,
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (event) => {
        event.preventDefault()
        event.stopPropagation()

        drawerCRUDStore.changeView(EDrawerView.RP_LIMIT_EDIT, String(row.original.id))
      },
      sx: {
        cursor: 'pointer',
      },
    }),
    renderTopToolbarCustomActions: () => {
      return (
        <Button
          variant="contained"
          onClick={() => {
            drawerCRUDStore.changeView(EDrawerView.RP_LIMIT_CREATE)
          }}>
          Создать новый лимит
        </Button>
      )
    },
  })
  return <MaterialReactTable table={table} />
})

export default RpLimitsTable
